import styled from 'styled-components';
import ScrollableWrapper from '../../ScrollableWrapper';
import ThinDivider from '../../ThinDivider';
import { overflowingStyles } from '../../../styles/shareableStyles';

export const Container = styled(ScrollableWrapper)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .simplebar-content {
    height: auto;
    min-height: 100%;
  }
`;

export const Text = styled.div`
  ${overflowingStyles};
`;

export const Divider = styled(ThinDivider)`
  margin-top: 8px;
`;
